import { SortIcon } from "@bookingcom/bui-assets-react/streamline";
import { Chip, DropdownMenu, Stack, Text } from "@bookingcom/bui-react";
import { t, useI18n } from "@bookingcom/lingojs-react";
import useCreateUrl from "../../../../hooks/useCreateUrl.js";
import useEventTracking from "../../../../hooks/useEventTracking.js";
import useGlobalContext from "../../../../hooks/useGlobalContext.js";
import React, { useCallback, useState } from "react";
import { useHistory } from "react-router-dom";
import { actions as searchActions } from "../../../../store/search/actions.js";
import { useDispatch, useSelector } from "react-redux";
import { getSort } from "../../../../store/search/selectors.js";
const defaultSortOption = "BEST";
const dropdownAttributes = { style: { width: 360 } };
const SearchSortSelector = ({ isSmall }) => {
    const i18n = useI18n();
    const history = useHistory();
    const { enhanceURLSearchParams } = useCreateUrl();
    const { requestId } = useGlobalContext();
    const dispatch = useDispatch();
    const sort = useSelector(getSort);
    const trackV2 = useEventTracking("search_results", requestId);
    const sortLabels = {
        BEST: { title: t("flights_search_sort_best"), subtitle: t("flights_search_sort_best_tooltip") },
        CHEAPEST: { title: t("flights_search_sort_cheapest") },
        FASTEST: { title: t("flights_search_sort_fastest") }
    };
    const [sorting, setSorting] = useState(() => {
        if (sort in sortLabels) {
            return sort;
        }
        return defaultSortOption;
    });
    const sortLabel = sortLabels[sorting];
    const sortName = sortLabel ? i18n.trans(sortLabel.title) : "";
    const handleItemChoose = useCallback((sort) => {
        setSorting(sort);
        dispatch(searchActions.setSortOrder(sort));
        setTimeout(() => {
            const params = new URLSearchParams(location.search);
            params.set("sort", sort);
            params.delete("page");
            params.delete("auto_load_page");
            enhanceURLSearchParams(params);
            history.replace({
                pathname: location.pathname,
                search: params.toString()
            }, { hideLoader: true });
        });
        trackV2("click_sort_by_link", sort);
    }, [dispatch, enhanceURLSearchParams, history, trackV2]);
    const items = Object.entries(sortLabels).map(([sort, { title, subtitle }]) => ({
        text: (React.createElement(Stack, { gap: 0 },
            React.createElement(Text, null, i18n.trans(title)),
            subtitle && (React.createElement(Text, { variant: "small_1", color: "neutral_alt" }, i18n.trans(subtitle))))),
        onChoose: () => handleItemChoose(sort)
    }));
    return (React.createElement(DropdownMenu, { position: "bottom-end", items: items, attributes: isSmall ? {} : dropdownAttributes }, (attributes) => (React.createElement(Chip, { variant: "action", label: i18n.trans(t("flights_sort_by_name", { variables: { sort_name: sortName } })), checked: true, icon: React.createElement(SortIcon, null), attributes: attributes }))));
};
export default SearchSortSelector;
